import { atom } from 'jotai'

export const showCreateUsageMetricDrawerAtom = atom(false)
